import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { usePromo } from "../Context/PromoContext";

export default function PlanDiscount() {

    const { promoMessages, loading } = usePromo();

    const getPromoForMenu = (menuName) => {
        const promo = promoMessages.find(
            (item) =>
            item.pageName &&
            item.pageName.toLowerCase() === menuName.toLowerCase()
        );

        if (!promo) return "";

        const match = promo.promoMessage?.match(/(\d+)%/);
        return match ? match[0] : "";
        };
    return (
        <div className="pt-100 pb-100">
            <div className="pb-40">
                <div className="container deals-offer-section">
                    <div className="row">
                        <div className="col-md-10 col-lg-8 col-xl-7 sal-animate m-auto text-center" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded m-auto"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>More Plans</small>
                            <h2 className="mb-0 text-center">
                                Let’s Think! What If You’ve Been Settling for the Wrong Hosting?
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row g-4">
                    <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                            <div className="mb-2">
                                <img src="/images/deals-shared-hosting.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6>
                                Linux Hosting
                            </h6>
                            <small className="d-block mb-2">
                                A budget-friendly web hosting solution where multiple websites share one server, perfect for small websites and beginners.
                            </small>
                                {getPromoForMenu('linux-hosting') ? (
                                    <h3 className="mt-4">
                                        <span className="discount-line">
                                            {getPromoForMenu('linux-hosting')} <sup>off</sup>
                                        </span>
                                    </h3>
                                ) : (
                                    <h3 className="mt-4"><span className="discount-line">No Deals</span></h3>
                                )}
                            <Link to="/linux-hosting" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6">
                                <span className="btn-arrow__text">
                                    Explore Plan
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                            <div className="mb-2">
                                <img src="/images/deals-dedicated-server.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6>
                                GPU Cloud Server India
                            </h6>
                            <small className="d-block mb-2">
                                High-performance and advanced GPU cloud servers for AI, ML, and challenging projects-fast, flexible, and low-latency across India.
                            </small>
                                {getPromoForMenu('gpu-cloud-server-india') ? (
                                    <h3 className="mt-4">
                                        <span className="discount-line">
                                            {getPromoForMenu('gpu-cloud-server-india')} <sup>off</sup>
                                        </span>
                                    </h3>
                                ): (
                                    <h3 className="mt-4"><span className="discount-line">No Deals</span></h3>
                                )}
                            <Link to="/gpu-cloud-server-india" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6">
                                <span className="btn-arrow__text">
                                    Explore Plan
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                            <div className="mb-2">
                                <img src="/images/deals-cloud-hosting.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6>
                                Cloud Hosting
                            </h6>
                            <small className="d-block mb-2">
                                Your site simply runs on a network of servers, not just one, meaning improved speed, advanced scaling, & fewer downtime worries.
                            </small>
                                {getPromoForMenu('cloud-hosting') ? (
                                    <h3 className="mt-4">
                                        <span className="discount-line">
                                            {getPromoForMenu('cloud-hosting')} <sup>off</sup>
                                        </span>
                                    </h3>
                                ): (
                                    <h3 className="mt-4"><span className="discount-line">No Deals</span></h3>
                                )}
                            <Link to="/cloud-hosting" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6">
                                <span className="btn-arrow__text">
                                    Explore Plan
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="600" data-sal-easing="ease-in-out-sine">
                        <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                            <div className="mb-2">
                                <img src="/images/deals-reseller-hosting.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6>
                                Reseller Hosting
                            </h6>
                            <small className="d-block mb-2">
                                Begin your own web hosting business by just selling server space under your brand name-quite simple, highly scalable, and more profitable.
                            </small>
                                {getPromoForMenu('linux-reseller-hosting') ? (
                                    <h3 className="mt-4">
                                        <span className="discount-line">
                                            {getPromoForMenu('linux-reseller-hosting')} <sup>off</sup>
                                        </span>
                                    </h3>
                                ): (
                                    <h3 className="mt-4"><span className="discount-line">No Deals</span></h3>
                                )}
                            <Link to="/linux-reseller-hosting" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6">
                                <span className="btn-arrow__text">
                                    Explore Plan
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                            <div className="mb-2">
                                <img src="/images/deals-windows-cloud-vps.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6>
                                Windows Cloud VPS
                            </h6>
                            <small className="d-block mb-2">
                                A virtual private server backed by Windows OS-ideal for apps, RDP access, and business tasks with flexible cloud performance.
                            </small>
                                {getPromoForMenu('windows-cloud-vps') ? (
                                    <h3 className="mt-4">
                                        <span className="discount-line">
                                            {getPromoForMenu('windows-cloud-vps')} <sup>off</sup>
                                        </span>
                                    </h3>
                                ): (
                                    <h3 className="mt-4"><span className="discount-line">No Deals</span></h3>
                                )}
                            <Link to="/windows-cloud-vps" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6">
                                <span className="btn-arrow__text">
                                    Explore Plan
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                            <div className="mb-2">
                                <img src="/images/deals-streaming-server.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6>
                                Streaming Server
                            </h6>
                            <small className="d-block mb-2">
                                A high-performance and modern server engineered to provide smooth, lag-free audio and video to your target viewers in real time.
                            </small>
                                {getPromoForMenu('streaming-server-new-york') ? (
                                    <h3 className="mt-4">
                                        <span className="discount-line">
                                            {getPromoForMenu('streaming-server-new-york')} <sup>off</sup>
                                        </span>
                                    </h3>
                                ): (
                                    <h3 className="mt-4"><span className="discount-line">No Deals</span></h3>
                                )}
                            <Link to="/streaming-server-new-york" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6">
                                <span className="btn-arrow__text">
                                    Explore Plan
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                            <div className="mb-2">
                                <img src="/images/deals-dedicated-server.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6>
                               Dedicated Server
                            </h6>
                            <small className="d-block mb-2">
                                A fully private, high-performance dedicated server with complete admin access-engineered for speed, stability, and serious tasks.
                            </small>
                                {getPromoForMenu('dedicated-server-new-york') ? (
                                    <h3 className="mt-4">
                                        <span className="discount-line">
                                            {getPromoForMenu('dedicated-server-new-york')} <sup>off</sup>
                                        </span>
                                    </h3>
                                ): (
                                    <h3 className="mt-4"><span className="discount-line">No Deals</span></h3>
                                )}
                            <Link to="/dedicated-server-new-york" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6">
                                <span className="btn-arrow__text">
                                    Explore Plan
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="600" data-sal-easing="ease-in-out-sine">
                        <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                            <div className="mb-2">
                                <img src="/images/deals-wordpress-hosting.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6>
                                Wordpress Hosting
                            </h6>
                            <small className="d-block mb-2">
                                Enhanced hosting engineered mainly for WordPress-quicker loading, instant management, and reliable performance for blogs, stores, etc.
                            </small>
                                {getPromoForMenu('wordpress-hosting') ? (
                                    <h3 className="mt-4">
                                        <span className="discount-line">
                                            {getPromoForMenu('wordpress-hosting')} <sup>off</sup>
                                        </span>
                                    </h3>
                                ): (
                                    <h3 className="mt-4"><span className="discount-line">No Deals</span></h3>
                                )}
                            <Link to="/wordpress-hosting" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6">
                                <span className="btn-arrow__text">
                                    Explore Plan
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}